import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

interface Props {
  cols?: number;
  rows?: number;
}

export default ({ cols = 8, rows = 6 }: Props) => {
  return (
    <main className="container-table-list">
      <table className="content-table">
        <tbody className="tbody-table-registros">
          {[...Array(rows)].map((_, i) => (
            <tr key={i} className="tr-table-registros">
              {[...Array(cols)].map((_, j) => (
                <td key={j} className="td-table-registros">
                  <Skeleton height={20} />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </main>
  );
};
